import { FC, memo } from "react";
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface SelectInputProps {
    label: string,
    value: string,
    options?: { value: string, label: string }[],
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    required?: boolean,
    children?: React.ReactNode
    ignore?: boolean
    disabled?: boolean
    helperText?: string
}

const SelectInput: FC<SelectInputProps> = ({ label, value, options, onChange, required = false, children, ignore = false, disabled = false, helperText }) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className={`input-holder`}>
            <label>{label}</label>
            <select
                value={value}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                required={required}
                data-ignore={ignore ? `true` : `false`}
                disabled={disabled || disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
            >
                {options && options.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
                {children}
            </select>
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(SelectInput)

